//登录模块
//引入工具函数
import request from "@/utils/request";

//授权登录
export const getUserInfoAndAccessTokenReq = (params) => {
  return request({
    method: "get",
    url: "/api/AuthLogin/GetUserInfoAndAccessToken",
    params,
  });
};
//授权登录
export const getUserInfoAndAccessTokenReq2 = () => {
  return request({
    method: "get",
    url: "/api/AuthLogin/GetUserInfoAndAccessToken1",
  });
};
